/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Shopping_ItemsInputs */

const en_plan_shopping_items = /** @type {(inputs: Plan_Shopping_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} left to buy`)
};

const de_plan_shopping_items = /** @type {(inputs: Plan_Shopping_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch ${i?.count} zu kaufen`)
};

/**
* | output |
* | --- |
* | "{count} left to buy" |
*
* @param {Plan_Shopping_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_shopping_items = /** @type {((inputs: Plan_Shopping_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Shopping_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_shopping_items(inputs)
	return en_plan_shopping_items(inputs)
});